<template>
  <ModalXD>
    <div class="person-container" v-if="person">
      <div class="input-wrapper">
        <h1 class="title">Oppdater person</h1>
      </div>
      <div class="input-wrapper">
        <div>
          <label>Posisjon:</label>
          <input type="number" placeholder="0" v-model="person.position" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Navn: </label>
          <input type="text" placeholder="Navn" v-model="person.name" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Tittel: </label>
          <input type="text" placeholder="Tittel" v-model="person.title" />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Gruppe: </label>
          <select v-model="person.group">
            <option :value="group" v-for="(group, i) in groups" :key="i">
              {{ group }}
            </option>
          </select>
        </div>
      </div>
      <!-- <div class="input-wrapper">
        <div>
          <label> Tlf: </label>
          <input
            type="text"
            placeholder="Telefon-nummer"
            v-model="person.tlf"
          />
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Email: </label>
          <input
            type="text"
            placeholder="Email-adresse"
            v-model="person.email"
          />
        </div>
      </div> -->
      <div class="input-wrapper">
        <div>
          <label> Bildetager: </label>
          <input type="text" placeholder="Trengs bare hvis bildet er tatt profesjonelt" v-model="person.cred" />
        </div>
      </div>
      <div class="input-wrapper" v-if="person.group == 'Andre bidragsytere'">
        <div>
          <label> Beskrivelse: </label>
          <textarea placeholder="Beskrivelse" v-model="person.description">
          </textarea>
        </div>
      </div>
      <div class="input-wrapper">
        <div>
          <label> Bilde: </label>
          <input @change="onFileChange" type="file" id="avatar" name="avatar" accept="image/*" />
        </div>
      </div>
      <div class="input-wrapper">
        <button @click="updatePerson">
          Oppdater<span class="material-icons">publish</span>
        </button>
        <button @click="cancelUpdate" class="cancel-button">
          Avbryt<span class="material-icons">cancel</span>
        </button>
      </div>
    </div>
  </ModalXD>
</template>

<script>
import ModalXD from "@/components/ModalXD.vue";
import { storage } from '@/database/storage'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
export default {
  name: "ModalPersonEdit",
  components: {
    ModalXD,
  },
  props: {
    selectedPerson: Object,
  },
  data() {
    return {
      file: null,
      avatar: null,
      userTypes: ["Admin", "Redaktør", "Observatør"],
      groups: ["Styret", "Poesiparkens venner", "Andre bidragsytere"],
      person: null,
      avatarChanged: false,
    };
  },
  watch: {
    avatar() {
      this.avatarChanged = true;
    },
  },
  mounted() {
    this.getPerson();
  },
  methods: {
    getPerson() {
      this.person = this.selectedPerson;
    },
    fileName(e) {
      this.selectedFile = e.target.files[0].name;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) this.file = file;
    },
    async updatePerson() {
      try {
        const payload = { ...this.person };

        if (this.file) {
          const fileName = `${Date.now()}_${this.file.name}`;
          const fileRef = storageRef(storage, `people/${fileName}`);
          await uploadBytes(fileRef, this.file);
          const url = await getDownloadURL(fileRef);
          payload.avatar = url;
        }

        if (payload.cred === "") payload.cred = null;

        if (!payload.docId) throw new Error("Person ID mangler!");

        await this.$store.dispatch("updatePerson", payload);
        this.avatarChanged = false;
        this.$emit("close");
        this.$toast.success("Person oppdatert!");
      } catch (err) {
        console.error(err);
        this.$toast.error("Oppdatering feilet");
      }
    },
    cancelUpdate() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.person-container {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;

  .input-wrapper {
    margin: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;
    width: 100%;

    * {
      width: 100%;
      margin: 5px;
      margin-right: 15px;
      padding: 0;
    }

    button {
      margin: 0px;
      padding: 20px;
      font-size: 1em;
      background: #2a8355;
      color: white;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      span {
        margin: 0 5px;
        width: fit-content;
      }
    }

    .cancel-button {
      background: #991111;
    }
  }
}

p {
  margin: 0;
  padding: 0;
  font-size: 1em;
}

.txt-ara {
  height: 10em;
  white-space: pre-wrap;
}

.custom-file-upload {
  padding: 20px;
  font-size: 1em;
  background: #2a8355;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
